import React from 'react'
import PageTransition from './templateParts/PageTransition'
import { useLoaderData } from 'react-router-dom'
import Title from './utils/Title/Title'
import Hero from './modules/Hero/Hero'
import './cmsStyles.scss'

export default function SinglePost() {
  const postData = useLoaderData()

  return (
    <PageTransition>
      <div className="post">
        <Hero
          data={{
            hero_title: `<h1>${postData?.title?.rendered}</h1> ${
              postData?.content?.rendered ?? postData?.content?.rendered
            }`,
            hero_type: true,
            hero_background_color: 'white',
            hero_background: {
              url: postData.featured_image.large,
            },
          }}
        />
        <div className="container">
          {postData?.acf?.info.map((info, index) => {
            return (
              <div className="text-container" key={index}>
                <Title title={info.title} />
                <div className="text" dangerouslySetInnerHTML={{ __html: info.content }} />
              </div>
            )
          })}
        </div>
      </div>
    </PageTransition>
  )
}
